import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=43045658&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43045658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43045658')) {
      api.createRecord('43045658', component.options)
    } else {
      api.reload('43045658', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=43045658&scoped=true", function () {
      api.rerender('43045658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/subViews/detail/Main.vue"
export default component.exports